const residentialVerificationIcon = '/images/residentialVerificationIcon.svg';

export const addressVerificationData = {
  data: {
    id: 2,
    type: 'address',
    icon: residentialVerificationIcon,
    title: 'Residential address verification',
    description: 'Please enter your residential address for verification',
    value: 'Please verify your home address',
    errorMessage:
      " We're sorry, but we couldn't verify your address at this time. Please ensure you've provided a verifiable means of identification and try again. If the issue persists, contact our support team for assistance via chat, email or call. support@smallsmall.com, 02013306045",
  },
};

export const lagosLGAsAndLCDAs = [
  // LGAs
  'Agege',
  'Ajeromi-Ifelodun',
  'Alimosho',
  'Amuwo-Odofin',
  'Apapa',
  'Badagry',
  'Epe',
  'Eti-Osa',
  'Ibeju-Lekki',
  'Ifako-Ijaiye',
  'Ikeja',
  'Ikorodu',
  'Kosofe',
  'Lagos Island',
  'Lagos Mainland',
  'Mushin',
  'Ojo',
  'Oshodi-Isolo',
  'Shomolu',
  'Surulere',

  // LCDAs
  'Agbado-Oke-Odo',
  'Agboyi-Ketu',
  'Apapa-Iganmu',
  'Ayobo-Ipaja',
  'Bariga',
  'Coker-Aguda',
  'Egbe-Idimu',
  'Ejigbo',
  'Igando-Ikotun',
  'Ikosi-Ejinrin',
  'Ikosi-Isheri',
  'Ikoyi-Obalende',
  'Isolo',
  'Itire-Ikate',
  'Iru-Victoria Island',
  'Odi-Olowo-Ojuwoye',
  'Ojodu',
  'Ojokoro',
  'Onigbongbo',
  'Orile-Agege',
  'Oshodi',
  'Oto-Awori',
  'Somolu',
  'Yaba',
];
